import React from 'react';
import Big from 'big.js';
import moment from 'moment';
import '../../OverdueContentAll/OverdueDetails/overdueDetails.scss';

const GarageDetails = ({ car }) => {
  return (
    <td colSpan="6">
      <div className="overdue-content-section">
        <div className="overdue-content-section-left">
          <div className="overdue-content-card">
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <h3 className="overdue-content-card-group-item-name">
                  <strong>
                    <big>{car?.cashBox && car.cashBox}</big>
                  </strong>
                </h3>
              </div>
              <div className="overdue-content-card-group-item">
                <p>{car?.basePercent && car.basePercent.toFixed(2)}% / день</p>
              </div>
            </div>
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <p>
                  <strong>
                    <big>{car?.refundAmount && car.refundAmount.toFixed(2)} руб.</big>
                  </strong>
                </p>
              </div>
            </div>
            <div className="overdue-content-card-group">
              <div className="overdue-content-card-group-item">
                <p className="overdue-date">
                  {car?.startDate && moment(car.startDate).format('DD.MM.YYYY')} -{' '}
                  {car?.endDate && moment(car.endDate).format('DD.MM.YYYY')}
                </p>
              </div>
              <div className="overdue-content-card-group-item">
                <p>
                  Процент за неустойку{' '}
                  {new Big(car.delayPercent).toFixed(2)}%
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="overdue-content-section-right">
          <table className="table hover overdue-table">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col" colSpan="3">
                  <p>Название</p>
                </th>
                <th scope="col">
                  <p>
                    Оценочная <br />
                    стоимость, руб.
                  </p>
                </th>
                <th scope="col">
                  <p>Количество</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {car &&
                car?.positions &&
                car.positions.length !== 0 &&
                car.positions.map((i, ind) => {

                  return (
                    <tr key={i.names && i.names !== 0 && i.names.join() + ind}>
                      <td>
                        <p>{ind + 1}</p>
                      </td>
                      <td colSpan="3">
                        <p>{i.names && i.names !== 0 && i.names.join(', ')}</p>
                      </td>
                      <td>
                        <p>
                          {car.totalEstimatedValue.toFixed(2)}
                        </p>
                      </td>
                      <td>
                        <p>{i.quantity}</p>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td colSpan="3">
                  <p>Итого</p>
                </td>
                <td>
                  <p>{car.totalEstimatedValue.toFixed(2)}</p>
                </td>
                <td>
                  <p>
                    {car.positions.reduce((p, c) => {
                      if (p) return p + c.quantity;
                      else return c.quantity;
                    }, 0)}
                  </p>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </td>
  );
};

export default GarageDetails;
